import React, { Component } from "react";

export default class ProjectsImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
    id="a6dc9487-50e2-4fb9-af91-bf1b7118d463"
    width={1103.79}
    height={707.8}
    data-name="Layer 1"
    viewBox="0 0 1103.79 707.8"
    xmlns="http://www.w3.org/2000/svg"
    
  >
    
    <defs id="defs139">
      <linearGradient
        id="bd43dd7f-2dfd-4389-bf1e-697a1c0f972b"
        x1={891.82}
        x2={891.82}
        y1={790.72}
        y2={522.9}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="gray" stopOpacity={0.25} id="stop132" />
        <stop offset={0.54} stopColor="gray" stopOpacity={0.12} id="stop134" />
        <stop offset={1} stopColor="gray" stopOpacity={0.1} id="stop136" />
      </linearGradient>
    </defs>
    <title id="title141">{"mind map"}</title>
    <ellipse
      cx={843.39}
      cy={664.8}
      fill={theme.imageHighlight}
      opacity={0.1}
      rx={192}
      ry={43}
      id="ellipse143"
    />
    <g opacity={0.1} id="g147">
      <path
        fill={theme.imageHighlight}
        d="M673.12,122.89c0,156.1,97.93,282.41,219,282.41"
        transform="translate(-48.1 -96.1)"
        id="path145"
      />
    </g>
    <path
      fill={theme.imageHighlight}
      d="M675.52,226.13c-70.75.54-138.73-15.45-203.73-33.27S342.32,155,273,146.82c-44.62-5.27-95.4-4.44-130.47,16-33.75,19.66-43.74,51.89-48.67,81.63-3.71,22.38-5.52,45.86,7.54,66.22C110.42,324.8,126,336.4,137,349.86c38.26,46.83,14.53,107.1-23.41,155.51-17.79,22.71-38.6,44.5-52.1,68.48s-19.18,51.1-5.79,74.6c13.28,23.28,43.54,40,76.09,51.45C197.92,723,275,727.6,350.05,729.06c166.14,3.25,332.71-6.63,498.83-16.5,61.47-3.66,123.22-7.34,183.48-17.15,33.46-5.45,67.92-13.44,91.74-30.61,30.25-21.8,36.68-57.11,15-82.33-36.37-42.29-133-49.68-159-95.53-14.31-25.24-1.57-54.37,17-78.92,39.94-52.64,108.35-100,110-158.62,1.1-40.25-34-79.28-86.68-96.43-55.25-18-130.79-12.79-169.85,21.61C810.34,210,738,225.66,675.52,226.13Z"
      opacity={0.1}
      transform="translate(-48.1 -96.1)"
      id="path149"
    />
    <path
      fill="#fff"
      d="M995,127.29V645.7c0,15.42-14.88,28-33.24,28H258.34c-18.36,0-33.23-12.54-33.23-28V127.29c0-15.45,14.87-31.19,33.23-31.19l703.33,1.71C980,97.81,995,111.84,995,127.29Z"
      transform="translate(-48.1 -96.1)"
      id="path151"
    />
    <path
      fill={theme.text}
      d="M995,127.45v24H225.11v-24A31.35,31.35,0,0,1,256.45,96.1H963.6A31.36,31.36,0,0,1,995,127.45Z"
      transform="translate(-48.1 -96.1)"
      id="path153"
    />
    <circle
      cx={214.3}
      cy={27.67}
      r={11.08}
      fill="#fa5959"
      opacity={0.8}
      id="circle155"
    />
    <circle
      cx={246.53}
      cy={27.67}
      r={11.08}
      fill="#fed253"
      opacity={0.8}
      id="circle157"
    />
    <circle
      cx={278.76}
      cy={27.67}
      r={11.08}
      fill="#8ccf4d"
      opacity={0.8}
      id="circle159"
    />
    <rect
      width={70.01}
      height={33.22}
      x={457}
      y={170.7}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      id="rect161"
    />
    <rect
      width={70.01}
      height={33.22}
      x={598.84}
      y={170.7}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      id="rect163"
    />
    <polyline
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      points="491.81 203.17 561.89 294.68 634.08 202.74"
      id="polyline165"
    />
    <rect
      width={107.03}
      height={50.79}
      x={508.37}
      y={291.75}
      opacity={0.1}
      rx={8.57}
      id="rect167"
    />
    <rect
      width={102.68}
      height={48.73}
      x={510.55}
      y={292.79}
      fill={theme.imageHighlight}
      rx={8.57}
      id="rect169"
    />
    <line
      x1={492.29}
      x2={491.38}
      y1={170.7}
      y2={138.35}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line171"
    />
    <polyline
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      points="675.22 139.93 634.08 170.7 590.81 139.93"
      id="polyline173"
    />
    <rect
      width={70.01}
      height={33.22}
      x={456.61}
      y={106.7}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      id="rect175"
    />
    <rect
      width={70.01}
      height={33.22}
      x={640.21}
      y={106.7}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      id="rect177"
    />
    <rect
      width={70.01}
      height={33.22}
      x={555.81}
      y={106.7}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      id="rect179"
    />
    <line
      x1={561.89}
      x2={561.62}
      y1={341.51}
      y2={430.01}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line181"
    />
    <path
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      d="M609.53,558.59v0Z"
      transform="translate(-48.1 -96.1)"
      id="path183"
    />
    <polyline
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      points="462.42 493.11 561.42 462.48 660.82 492.89"
      id="polyline185"
    />
    <rect
      width={70.01}
      height={33.22}
      x={526.62}
      y={430.01}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      id="rect187"
    />
    <rect
      width={70.01}
      height={33.22}
      x={861.88}
      y={345.12}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(1210.51 -631.25) rotate(90)"
      id="rect189"
    />
    <rect
      width={70.01}
      height={33.22}
      x={861.88}
      y={454.76}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(377.41 1272.15) rotate(-90)"
      id="rect191"
    />
    <rect
      width={70.01}
      height={33.22}
      x={625.82}
      y={492.66}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      id="rect193"
    />
    <rect
      width={70.01}
      height={33.22}
      x={475.52}
      y={588.76}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(972.95 1114.65) rotate(-180)"
      id="rect195"
    />
    <rect
      width={70.01}
      height={33.22}
      x={576.46}
      y={588.76}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(1174.83 1114.65) rotate(-180)"
      id="rect197"
    />
    <line
      x1={801}
      x2={832.16}
      y1={320.45}
      y2={374.94}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line199"
    />
    <line
      x1={735.11}
      x2={767.82}
      y1={319.78}
      y2={319.78}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line201"
    />
    <line
      x1={613.23}
      x2={702.51}
      y1={317.15}
      y2={319.78}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line203"
    />
    <line
      x1={832.16}
      x2={801.15}
      y1={265.63}
      y2={320.21}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line205"
    />
    <rect
      width={70.01}
      height={33.22}
      x={732.22}
      y={399.07}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(1134.8 -447.65) rotate(90)"
      id="rect207"
    />
    <rect
      width={70.01}
      height={33.22}
      x={797.48}
      y={399.94}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(1200.94 -512.04) rotate(90)"
      id="rect209"
    />
    <rect
      width={70.01}
      height={33.22}
      x={288.1}
      y={345.12}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(636.73 -57.48) rotate(90)"
      id="rect211"
    />
    <rect
      width={70.01}
      height={33.22}
      x={288.1}
      y={454.76}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(-196.37 698.37) rotate(-90)"
      id="rect213"
    />
    <line
      x1={322.78}
      x2={291.61}
      y1={320.45}
      y2={374.94}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line215"
    />
    <line
      x1={388.66}
      x2={355.96}
      y1={319.78}
      y2={319.78}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line217"
    />
    <line
      x1={510.55}
      x2={421.27}
      y1={317.15}
      y2={319.78}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line219"
    />
    <line
      x1={291.61}
      x2={322.62}
      y1={265.63}
      y2={320.21}
      fill="none"
      stroke={theme.text}
      strokeMiterlimit={10}
      id="line221"
    />
    <rect
      width={70.01}
      height={33.22}
      x={417.76}
      y={399.07}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(820.34 -133.18) rotate(90)"
      id="rect223"
    />
    <rect
      width={70.01}
      height={33.22}
      x={352.49}
      y={399.94}
      fill={theme.imageHighlight}
      opacity={0.2}
      rx={8.57}
      transform="translate(755.94 -67.05) rotate(90)"
      id="rect225"
    />
    <path
      fill={theme.text}
      d="M156.12,598c0,50.24,31.52,90.9,70.47,90.9"
      transform="translate(-48.1 -96.1)"
      id="path227"
    />
    <path
      fill={theme.imageHighlight}
      d="M226.59,688.89c0-50.81,35.18-91.92,78.65-91.92"
      transform="translate(-48.1 -96.1)"
      id="path229"
    />
    <path
      fill={theme.imageHighlight}
      d="M181.66,602.55c0,47.72,20.1,86.34,44.93,86.34"
      transform="translate(-48.1 -96.1)"
      id="path231"
    />
    <path
      fill={theme.text}
      d="M226.59,688.89c0-64.92,40.66-117.45,90.9-117.45"
      transform="translate(-48.1 -96.1)"
      id="path233"
    />
    <ellipse
      cx={175.43}
      cy={607.19}
      fill={theme.imageHighlight}
      opacity={0.1}
      rx={17.52}
      ry={2.96}
      id="ellipse235"
    />
    <path
      fill="#a8a8a8"
      d="M211.77,689.53s10-.31,13-2.45,15.37-4.71,16.12-1.27,15,17.11,3.73,17.2-26.22-1.76-29.22-3.59S211.77,689.53,211.77,689.53Z"
      transform="translate(-48.1 -96.1)"
      id="path237"
    />
    <path
      d="M244.83,701.81c-11.28.09-26.21-1.75-29.22-3.59-2.29-1.39-3.2-6.39-3.51-8.7h-.33s.63,8.06,3.64,9.89,17.94,3.68,29.22,3.59c3.26,0,4.38-1.19,4.32-2.9C248.5,701.15,247.26,701.79,244.83,701.81Z"
      opacity={0.2}
      transform="translate(-48.1 -96.1)"
      id="path239"
    />
    <circle cx={730.3} cy={557} r={1.13} fill={theme.compImgHighlight} id="circle281" />
    <g
      id="freepik--Character--inject-773"
      transform="translate(767.81018,203.10497)"
    >
      <path
        d="m 158.16,109 a 11.64,11.64 0 0 0 -10.25,-9.75 15.32,15.32 0 0 1 -4,-0.44 23,23 0 0 1 -2.85,-1.63 7.77,7.77 0 0 0 -9.49,2 c -2,2.61 -2.87,-1 -7.68,1.84 -4,2.37 -1.9,5.66 -1.9,5.66 a 8.93,8.93 0 0 0 -8.85,7.06 c -0.47,2.57 0,5.69 -2,7.37 -1,0.81 -2.32,1 -3.33,1.81 -1.86,1.44 -1.92,4.22 -1.5,6.53 0.42,2.31 1.14,4.76 0.28,7 -1.41,3.59 -6.52,5 -7.15,8.82 -0.3,1.8 0.45,4 -0.8,5.28 a 6.08,6.08 0 0 1 -1.88,1.1 8.13,8.13 0 0 0 -0.3,14.45 c 0.72,0.39 1.59,0.76 1.86,1.54 0.27,0.78 -0.26,1.77 -0.67,2.59 a 7.82,7.82 0 0 0 11.12,10.14 12.21,12.21 0 0 0 7.23,5.63 7.4,7.4 0 0 0 4.27,0.11 8.28,8.28 0 0 0 2.94,-1.8 c 4.16,-3.63 10,-9.17 10.38,-14.68"
        fill={theme.text}
        id="path1219"
      />
      <path
        d="m 119.9,129.08 a 4.9,4.9 0 0 1 -1.93,0 11.34,11.34 0 0 1 -7.65,-5 4.7,4.7 0 0 1 -0.81,-1.74 15.31,15.31 0 0 1 1.11,1.53 13.35,13.35 0 0 0 3.29,3 13.51,13.51 0 0 0 4.13,1.75 14.67,14.67 0 0 1 1.86,0.46 z"
        fill={theme.text}
        id="path1221"
      />
      <path
        d="m 122.69,116.43 a 4.2,4.2 0 0 1 -1.25,1.25 11.08,11.08 0 0 1 -8.11,2.07 4.2,4.2 0 0 1 -1.7,-0.5 18,18 0 0 0 5.83,-0.24 17.61,17.61 0 0 0 5.23,-2.58 z"
        fill={theme.text}
        id="path1223"
      />
      <path
        d="m 102.25,179 c 0,0 -0.06,0 -0.17,0 a 4.63,4.63 0 0 1 -0.5,-0.15 6.11,6.11 0 0 1 -1.72,-1 6.63,6.63 0 0 1 -2,-2.43 6.5,6.5 0 0 1 -0.48,-4.1 6.75,6.75 0 0 1 0.89,-2.26 8.81,8.81 0 0 1 1.76,-2 9.26,9.26 0 0 0 1.82,-2 2.7,2.7 0 0 0 0.08,-2.59 13.06,13.06 0 0 0 -1.79,-2.43 8.83,8.83 0 0 1 -0.93,-1.34 5.1,5.1 0 0 1 -0.54,-1.61 5.7,5.7 0 0 1 3.1,-5.87 18.66,18.66 0 0 1 3.38,-0.79 3.87,3.87 0 0 0 1.44,-0.61 2.29,2.29 0 0 0 0.83,-1.2 4.77,4.77 0 0 0 -0.33,-3 c -0.39,-0.95 -0.93,-1.85 -1.28,-2.81 a 4.5,4.5 0 0 1 -0.21,-3 4.85,4.85 0 0 1 1.71,-2.29 13.19,13.19 0 0 1 4.62,-1.94 10.31,10.31 0 0 0 3.64,-1.66 4.58,4.58 0 0 0 1.52,-2.53 2.85,2.85 0 0 0 -0.18,-1.86 c -0.19,-0.4 -0.37,-0.56 -0.34,-0.58 a 1.54,1.54 0 0 1 0.44,0.53 2.91,2.91 0 0 1 0.28,1.94 4.66,4.66 0 0 1 -1.53,2.72 10.21,10.21 0 0 1 -3.73,1.79 13,13 0 0 0 -4.45,1.93 4.31,4.31 0 0 0 -1.54,2.09 4,4 0 0 0 0.22,2.71 c 0.34,0.92 0.87,1.79 1.29,2.79 a 5.27,5.27 0 0 1 0.36,3.3 2.84,2.84 0 0 1 -1,1.47 4.38,4.38 0 0 1 -1.63,0.71 18.49,18.49 0 0 0 -3.28,0.75 5.19,5.19 0 0 0 -2.81,5.32 4.74,4.74 0 0 0 0.47,1.45 8.46,8.46 0 0 0 0.88,1.27 12.82,12.82 0 0 1 1.83,2.54 3.17,3.17 0 0 1 -0.12,3 9.13,9.13 0 0 1 -1.92,2.07 8.45,8.45 0 0 0 -1.71,1.85 6.39,6.39 0 0 0 -0.87,2.13 6.21,6.21 0 0 0 0.38,3.9 6.59,6.59 0 0 0 1.83,2.39 8.32,8.32 0 0 0 2.29,1.4 z"
        fill={theme.text}
        id="path1225"
      />
      <rect
        x={98.32}
        y={429.29999}
        width={107.71}
        height={5.7199998}
        fill={theme.compImgHighlight}
        id="rect1227"
      />
      <path
        d="m 206,435 c 0,0 0,-0.13 0,-0.36 0,-0.23 0,-0.6 0,-1.06 0,-1 0,-2.38 -0.05,-4.3 l 0.08,0.08 c -14,0.1 -56.95,0.18 -107.71,0.18 v 0 l 0.26,-0.26 V 435 l -0.26,-0.26 76.28,0.11 23,0.08 h 6.25 1.63 0.57 -0.53 -1.6 -6.19 l -22.92,0.08 -76.47,0.11 H 98.08 V 429 h 0.26 c 50.76,0 93.74,0.07 107.71,0.18 h 0.08 v 0.08 c 0,1.94 0,3.37 -0.05,4.34 0,0.46 0,0.8 0,1.05 A 2.06,2.06 0 0 1 206,435 Z"
        fill={theme.text}
        id="path1229"
      />
      <polygon
        points="115.02,332.16 115.02,330.16 109.6,330.16 86.86,483.78 94.44,483.78 "
        fill={theme.compImgHighlight}
        id="polygon1231"
      />
      <path
        d="m 109.6,330.16 c 0,0 0.41,0 1.3,0 h 4.12 0.07 v 0.07 c 0,0.6 0,1.27 0,2 v 0 c -2.46,18.91 -10.62,79.63 -20.4,151.64 v 0.23 h -8.13 v -0.3 C 93,441 98.7,402.55 102.83,374.8 c 2.08,-13.84 3.76,-25 4.93,-32.73 0.58,-3.84 1,-6.82 1.35,-8.86 l 0.35,-2.29 c 0.09,-0.51 0.14,-0.76 0.14,-0.76 0,0 0,0.27 -0.1,0.8 -0.1,0.53 -0.18,1.32 -0.33,2.33 -0.29,2 -0.72,5 -1.28,8.92 -1.12,7.74 -2.75,18.94 -4.77,32.81 -4.08,27.71 -9.72,66.08 -16,108.8 l -0.26,-0.3 h 7.59 l -0.26,0.22 C 104,411.73 112.28,351 115,332.15 v 0 c 0,-0.73 0,-1.4 0,-2 l 0.06,0.06 h -4.08 z"
        fill={theme.text}
        id="path1233"
      />
      <polygon
        points="189.3,332.16 189.3,330.16 194.72,330.16 217.94,483.78 210.35,483.78 "
        fill={theme.compImgHighlight}
        id="polygon1235"
      />
      <path
        d="m 194.72,330.16 h -1.34 -4.08 l 0.06,-0.06 c 0,0.6 0,1.27 0,2 v 0 c 2.73,18.88 11.24,79.57 21.24,151.59 l -0.25,-0.22 h 7.58 l -0.26,0.3 c -6.41,-42.71 -12.18,-81.09 -16.34,-108.8 -2.06,-13.87 -3.72,-25.06 -4.88,-32.81 -0.56,-3.87 -1,-6.87 -1.31,-8.92 -0.14,-1 -0.25,-1.79 -0.33,-2.33 -0.08,-0.54 -0.1,-0.8 -0.1,-0.8 0,0 0.05,0.25 0.14,0.76 0.09,0.51 0.2,1.3 0.36,2.29 0.32,2 0.78,5 1.38,8.86 1.19,7.72 2.9,18.89 5,32.73 4.22,27.75 10.06,66.17 16.57,108.94 v 0.3 h -8.11 v -0.23 c -10,-72 -18.36,-132.73 -20.88,-151.64 v 0 c 0,-0.73 0,-1.4 0,-2 v -0.07 h 0.07 4.11 c 0.96,0.09 1.37,0.11 1.37,0.11 z"
        fill={theme.text}
        id="path1237"
      />
      <rect
        x={146.46001}
        y={330.16}
        width={6.48}
        height={153.62}
        fill={theme.compImgHighlight}
        id="rect1239"
      />
      <path
        d="m 152.94,483.78 c 0,0 0,-0.28 0,-0.81 0,-0.53 0,-1.31 0,-2.32 0,-2 0,-5.06 0,-8.92 0,-7.75 -0.05,-18.94 -0.08,-32.8 0,-27.71 -0.07,-66.08 -0.11,-108.77 l 0.26,0.26 h -6.48 l 0.26,-0.26 c 0,73.55 -0.08,135.5 -0.19,153.62 l -0.07,-0.07 h 4.89 1.19 0.4 -0.37 -1.18 -4.93 -0.07 v -0.07 c -0.11,-18.12 -0.19,-80.07 -0.19,-153.62 v -0.26 h 7 v 0.26 c 0,42.77 -0.08,81.2 -0.1,109 0,13.84 -0.07,25 -0.08,32.74 0,3.84 0,6.82 0,8.86 0,1 0,1.76 0,2.29 0,0.53 -0.15,0.87 -0.15,0.87 z"
        fill={theme.text}
        id="path1241"
      />
      <rect
        x={107.1}
        y={319.89001}
        width={88.910004}
        height={11.55}
        fill={theme.text}
        id="rect1243"
      />
      <path
        d="M 134.25,320.22 A 27,27 0 0 1 131,323 a 35.36,35.36 0 0 1 -3.9,2.45 34.93,34.93 0 0 1 -10.61,3.66 33.87,33.87 0 0 1 -4.58,0.47 27.19,27.19 0 0 1 -4.23,-0.15 h 0.32 0.85 c 0.72,0 1.78,0 3.08,0 a 35.69,35.69 0 0 0 4.55,-0.51 40,40 0 0 0 5.43,-1.41 40.94,40.94 0 0 0 5.13,-2.23 36.65,36.65 0 0 0 3.9,-2.4 c 1.06,-0.76 1.9,-1.41 2.45,-1.89 l 0.64,-0.54 z"
        fill={theme.text}
        id="path1245"
      />
      <path
        d="m 147,327.81 -0.22,-0.08 c -0.14,-0.06 -0.35,-0.17 -0.63,-0.28 a 12,12 0 0 0 -2.56,-0.66 11.85,11.85 0 0 0 -4.14,0.15 11.28,11.28 0 0 0 -4.86,2.36 v -0.14 a 37.86,37.86 0 0 0 9.83,1.07 37.05,37.05 0 0 0 5.63,-0.57 8.46,8.46 0 0 0 2.8,-0.82 2.07,2.07 0 0 0 0.91,-1.09 2.2,2.2 0 0 0 -0.05,-1.43 3.56,3.56 0 0 0 -2.59,-2.1 19.84,19.84 0 0 0 -3.41,-0.47 36.06,36.06 0 0 0 -6.52,0.13 37.5,37.5 0 0 0 -17.2,6.4 c -0.73,0.49 -1.27,0.92 -1.64,1.2 l -0.57,0.42 c 0,0 0.18,-0.16 0.55,-0.45 0.37,-0.29 0.88,-0.73 1.61,-1.23 a 35.24,35.24 0 0 1 6.52,-3.67 36.86,36.86 0 0 1 10.7,-2.86 37.5,37.5 0 0 1 6.57,-0.15 20.88,20.88 0 0 1 3.45,0.48 5.15,5.15 0 0 1 1.63,0.76 3.2,3.2 0 0 1 1.09,1.47 2.29,2.29 0 0 1 0,1.57 2.16,2.16 0 0 1 -1,1.19 8.6,8.6 0 0 1 -2.87,0.85 36.39,36.39 0 0 1 -5.67,0.56 37.21,37.21 0 0 1 -9.87,-1.1 h -0.15 l 0.12,-0.1 a 11.38,11.38 0 0 1 5,-2.37 11.67,11.67 0 0 1 4.17,-0.11 10.94,10.94 0 0 1 2.57,0.71 c 0.49,0.21 0.8,0.36 0.8,0.36 z"
        fill={theme.text}
        id="path1247"
      />
      <path
        d="m 158.49,320.19 a 2.09,2.09 0 0 1 0.6,0.16 4.26,4.26 0 0 1 1.4,1 4.9,4.9 0 0 1 1.19,2.22 5.5,5.5 0 0 1 -0.25,3.08 7.4,7.4 0 0 1 -3.84,3.95 9.83,9.83 0 0 1 -1.59,0.58 l -0.45,0.11 c -0.11,0 -0.16,0 -0.16,0 a 3.77,3.77 0 0 1 0.58,-0.21 10.3,10.3 0 0 0 1.55,-0.64 7.33,7.33 0 0 0 3.71,-3.89 5.24,5.24 0 0 0 0.26,-3 4.79,4.79 0 0 0 -1.11,-2.17 4.72,4.72 0 0 0 -1.89,-1.19 z"
        fill={theme.text}
        id="path1249"
      />
      <path
        d="m 172.41,320.14 a 14.44,14.44 0 0 0 -1.95,1 13.27,13.27 0 0 0 -3.73,3.66 29.1,29.1 0 0 0 -2.52,4.63 l -0.66,1.46 c -0.16,0.34 -0.25,0.53 -0.26,0.53 a 2.33,2.33 0 0 1 0.18,-0.56 c 0.14,-0.36 0.34,-0.87 0.6,-1.49 a 25.4,25.4 0 0 1 2.49,-4.69 12.72,12.72 0 0 1 3.82,-3.67 8.49,8.49 0 0 1 1.46,-0.69 4.33,4.33 0 0 1 0.42,-0.13 c 0.09,-0.05 0.15,-0.06 0.15,-0.05 z"
        fill={theme.text}
        id="path1251"
      />
      <path
        d="m 187.77,327 -0.52,-0.23 a 8.94,8.94 0 0 0 -1.53,-0.49 8.74,8.74 0 0 0 -5.75,0.64 1.61,1.61 0 0 0 -0.72,0.56 0.67,0.67 0 0 0 0.09,0.83 5.25,5.25 0 0 0 1.87,0.9 18.5,18.5 0 0 0 4.58,1 19.19,19.19 0 0 0 5.15,-0.25 5.23,5.23 0 0 0 2.46,-1 2.16,2.16 0 0 0 0.56,-2.47 3.6,3.6 0 0 0 -1.89,-1.91 12.3,12.3 0 0 0 -2.59,-0.86 18.2,18.2 0 0 0 -5.14,-0.42 17.77,17.77 0 0 0 -8.28,2.63 18.52,18.52 0 0 0 -4.45,3.86 c -0.45,0.55 -0.77,1 -1,1.29 l -0.33,0.46 a 14.1,14.1 0 0 1 1.24,-1.8 18.66,18.66 0 0 1 4.48,-4.04 17.85,17.85 0 0 1 8.35,-2.69 18.26,18.26 0 0 1 5.2,0.41 12.29,12.29 0 0 1 2.63,0.87 3.87,3.87 0 0 1 2,2 2.61,2.61 0 0 1 0.13,1.46 2.38,2.38 0 0 1 -0.75,1.24 5.37,5.37 0 0 1 -2.56,1.08 19.24,19.24 0 0 1 -5.21,0.25 19.78,19.78 0 0 1 -4.62,-1 c -0.35,-0.12 -0.69,-0.26 -1,-0.39 a 2.44,2.44 0 0 1 -0.91,-0.58 0.83,0.83 0 0 1 -0.1,-1 1.9,1.9 0 0 1 0.78,-0.61 8.8,8.8 0 0 1 5.84,-0.58 7,7 0 0 1 1.99,0.84 z"
        fill={theme.text}
        id="path1253"
      />
      <path
        d="m 130.13,173 a 15.08,15.08 0 0 0 -7.75,6.73 c -2.91,5.15 -2.13,7.69 -1.37,10.74 0.76,3.05 2.1,9.08 2.17,8.69 0.07,-0.39 6.95,-26.16 6.95,-26.16 z"
        style={{
          fill: "#a36957",
        }}
        id="path1255"
      />
      <polygon
        points="136.57,169.4 165.02,158.75 159.43,206.57 138.43,219.79 125.99,213.57 124.75,199.73 130.45,173.03 "
        style={{
          fill: "#a36957",
        }}
        id="polygon1257"
      />
      <polygon
        points="118.59,260.22 104.81,256.98 93.79,263.14 96.71,268.33 125.95,270.29 136.26,249.04 129.71,245.8 "
        style={{
          fill: "#7c3b29",
        }}
        id="polygon1259"
      />
      <polygon
        points="95.97,384.22 107.19,408.54 125.29,400.17 113.69,370.08 "
        style={{
          fill: "#a36957",
        }}
        id="polygon1261"
      />
      <path
        d="m 105.07,406.91 6.55,12.5 c 0,0 -16.78,17.35 -15.2,21.23 L 135.86,421.73 125,396.66 Z"
        style={{
          fill: "#ff725e",
        }}
        id="path1263"
      />
      <path
        d="m 123,411.85 a 1.79,1.79 0 0 1 2,1.31 1.72,1.72 0 0 1 -1.27,2 1.89,1.89 0 0 1 -2.11,-1.39 1.79,1.79 0 0 1 1.56,-1.93"
        fill={theme.compImgHighlight}
        id="path1265"
      />
      <g
        style={{
          opacity: 0.6,
        }}
        id="g1269"
      >
        <path
          d="M 135.86,421.73 134.22,418.58 97,437.89 c 0,0 -1.39,1.6 -0.6,2.75 z"
          style={{
            fill: "#ffffff",
          }}
          id="path1267"
        />
      </g>
      <path
        d="m 110.89,419.52 c 0.09,0.19 1.1,-0.19 2.34,0 1.24,0.19 2.14,0.73 2.28,0.57 0.14,-0.16 -0.68,-1.14 -2.19,-1.31 -1.51,-0.17 -2.56,0.58 -2.43,0.74 z"
        fill={theme.text}
        id="path1271"
      />
      <path
        d="m 107.57,423.21 c 0,0.21 1,0.14 2.08,0.64 1.08,0.5 1.65,1.27 1.83,1.17 0.18,-0.1 -0.21,-1.25 -1.52,-1.85 -1.31,-0.6 -2.48,-0.17 -2.39,0.04 z"
        fill={theme.text}
        id="path1273"
      />
      <path
        d="m 107.59,429.29 c 0.2,0 0,-1.14 -1,-2 -1,-0.86 -2.1,-0.81 -2.1,-0.61 0,0.2 0.82,0.5 1.63,1.18 0.81,0.68 1.27,1.5 1.47,1.43 z"
        fill={theme.text}
        id="path1275"
      />
      <path
        d="m 109,414.7 c 0.17,0.14 0.92,-0.55 2,-1 1.08,-0.45 2.14,-0.51 2.16,-0.72 0.02,-0.21 -1.13,-0.51 -2.44,0 -1.31,0.51 -1.88,1.62 -1.72,1.72 z"
        fill={theme.text}
        id="path1277"
      />
      <path
        d="m 107.85,412.2 c 0,0 -0.2,-0.25 -0.37,-0.79 a 5.78,5.78 0 0 1 -0.18,-2.38 2.84,2.84 0 0 1 0.18,-0.8 1,1 0 0 1 0.79,-0.64 0.71,0.71 0 0 1 0.59,0.2 1,1 0 0 1 0.24,0.54 6.54,6.54 0 0 1 0,1 c 0,0.67 0,1.31 -0.16,2.08 a 1.25,1.25 0 0 1 -0.82,1 2.46,2.46 0 0 1 -1.23,0.05 9.9,9.9 0 0 1 -3.13,-1.11 2.86,2.86 0 0 1 -0.88,-0.67 0.93,0.93 0 0 1 0,-1.17 1.11,1.11 0 0 1 1,-0.25 6.76,6.76 0 0 1 1.55,0.63 8.45,8.45 0 0 1 1.91,1.42 c 0.39,0.4 0.57,0.65 0.54,0.68 a 15.82,15.82 0 0 0 -2.62,-1.77 6.58,6.58 0 0 0 -1.45,-0.54 0.73,0.73 0 0 0 -0.64,0.13 0.48,0.48 0 0 0 0.06,0.58 2.55,2.55 0 0 0 0.74,0.52 8.67,8.67 0 0 0 0.92,0.44 9.72,9.72 0 0 0 2,0.6 2,2 0 0 0 1,0 0.72,0.72 0 0 0 0.49,-0.6 c 0.09,-0.64 0.12,-1.38 0.18,-2 a 5.94,5.94 0 0 0 0,-0.91 c 0,-0.26 -0.14,-0.38 -0.33,-0.37 -0.43,0 -0.58,0.61 -0.65,1.07 a 8.2,8.2 0 0 0 0.27,3.06 z"
        fill={theme.text}
        id="path1279"
      />
      <path
        d="M 95.71,392.57 67.14,321.46 c 0,0 0.66,-12.62 3,-16.61 2.34,-3.99 72.76,-27.25 72.76,-27.25 0,0 17.94,-4.31 29.9,0 11.96,4.31 20.93,19.28 19.27,27.58 -1.66,8.3 -8.67,14.41 -8.67,14.41 l -51.8,1.54 -28.23,10.3 19,54.5 c 0,0 -9.71,10.63 -26.66,6.64 z"
        fill={theme.text}
        id="path1281"
      />
      <polygon
        points="70.41,344.9 69.74,371.67 89.68,372.15 92.55,340.03 "
        style={{
          fill: "#a36957",
        }}
        id="polygon1283"
      />
      <path
        d="m 68.55,369.27 0.37,14.11 c 0,0 -22.71,8.16 -23,12.34 l 43.73,0.44 1.35,-27.28 z"
        style={{
          fill: "#ff725e",
        }}
        id="path1285"
      />
      <path
        d="m 82.46,381.62 a 1.8,1.8 0 0 1 1.22,2.06 1.73,1.73 0 0 1 -2,1.22 1.89,1.89 0 0 1 -1.27,-2.18 1.78,1.78 0 0 1 2.24,-1"
        fill={theme.compImgHighlight}
        id="path1287"
      />
      <g
        style={{
          opacity: 0.6,
        }}
        id="g1291"
      >
        <path
          d="m 89.64,396.16 -0.08,-3.55 -41.9,0.91 c 0,0 -2,0.82 -1.75,2.2 z"
          style={{
            fill: "#ffffff",
          }}
          id="path1289"
        />
      </g>
      <path
        d="m 68.21,383.15 c 0,0.22 1.07,0.32 2.12,1 1.05,0.68 1.59,1.6 1.79,1.52 0.2,-0.08 -0.11,-1.32 -1.39,-2.14 -1.28,-0.82 -2.56,-0.53 -2.52,-0.38 z"
        fill={theme.text}
        id="path1293"
      />
      <path
        d="m 63.61,385 c -0.06,0.21 0.87,0.58 1.58,1.49 0.71,0.91 0.92,1.87 1.13,1.86 0.21,-0.01 0.36,-1.21 -0.55,-2.32 -0.91,-1.11 -2.16,-1.23 -2.16,-1.03 z"
        fill={theme.text}
        id="path1295"
      />
      <path
        d="m 60.94,390.47 c 0.2,0 0.51,-1 0,-2.19 -0.51,-1.19 -1.53,-1.65 -1.62,-1.48 -0.09,0.17 0.52,0.81 0.94,1.78 0.42,0.97 0.47,1.86 0.68,1.89 z"
        fill={theme.text}
        id="path1297"
      />
      <path
        d="m 68.65,378 c 0.09,0.2 1.07,-0.09 2.28,0 1.21,0.09 2.14,0.48 2.25,0.3 0.11,-0.18 -0.78,-0.95 -2.2,-1 -1.42,-0.05 -2.43,0.53 -2.33,0.7 z"
        fill={theme.text}
        id="path1299"
      />
      <path
        d="m 68.71,375.25 a 2,2 0 0 1 0,-0.87 5.83,5.83 0 0 1 0.88,-2.22 3.25,3.25 0 0 1 0.52,-0.64 1,1 0 0 1 1,-0.22 0.71,0.71 0 0 1 0.44,0.44 1,1 0 0 1 0,0.59 7.38,7.38 0 0 1 -0.46,0.89 c -0.34,0.57 -0.63,1.15 -1.06,1.79 a 1.24,1.24 0 0 1 -1.17,0.53 2.38,2.38 0 0 1 -1.13,-0.5 10.23,10.23 0 0 1 -1.67,-1.53 c -0.23,-0.28 -0.45,-0.56 -0.65,-0.85 a 2.74,2.74 0 0 1 -0.49,-1 0.92,0.92 0 0 1 0.5,-1.07 1.1,1.1 0 0 1 1,0.24 6.6,6.6 0 0 1 1.11,1.26 8.34,8.34 0 0 1 1.09,2.11 2.42,2.42 0 0 1 0.19,0.85 16.21,16.21 0 0 0 -1.58,-2.74 6.62,6.62 0 0 0 -1.06,-1.13 0.74,0.74 0 0 0 -0.63,-0.17 0.47,0.47 0 0 0 -0.2,0.55 2.39,2.39 0 0 0 0.43,0.79 9.31,9.31 0 0 0 0.63,0.81 9.91,9.91 0 0 0 1.6,1.46 2.22,2.22 0 0 0 0.89,0.41 0.75,0.75 0 0 0 0.71,-0.33 c 0.36,-0.53 0.71,-1.18 1,-1.72 a 6,6 0 0 0 0.44,-0.8 c 0.09,-0.25 0,-0.41 -0.13,-0.48 -0.4,-0.16 -0.79,0.29 -1.06,0.67 a 8.35,8.35 0 0 0 -1.14,2.88 z"
        fill={theme.text}
        id="path1301"
      />
      <path
        d="m 82.05,270.58 c 0,0 -12,-0.95 -13.27,12 C 67.51,295.53 66.14,356 66.14,356 l 27.91,2.33 4.32,-61.81 44.53,-18.92 c 0,0 -52.9,-8.68 -60.85,-7.02 z"
        fill={theme.text}
        id="path1303"
      />
      <path
        d="m 131.28,253.1 c 0,0 -7.25,20.32 -5.87,22.59 1.38,2.27 20,11.58 20,11.58 l 46.64,17.91 a 39.08,39.08 0 0 0 4.79,-19.32 c 0,-11.71 -16.22,-32.76 -16.22,-32.76 z"
        fill={theme.text}
        id="path1305"
      />
      <path
        d="m 145.1,276.57 c 0,0 -0.07,0 -0.22,0.12 l -0.66,0.3 -2.58,1.15 -9.7,4.23 -33.47,14.4 0.15,-0.21 c -0.42,6.11 -0.88,12.7 -1.35,19.52 -1.14,15.95 -2.18,30.65 -3,42.28 v 0.21 h -0.2 l -20.37,-1.8 -5.6,-0.52 -1.46,-0.16 a 2.5,2.5 0 0 1 -0.5,-0.07 2.79,2.79 0 0 1 0.51,0 l 1.46,0.09 5.61,0.41 20.35,1.61 -0.22,0.19 c 0.79,-11.63 1.8,-26.34 2.9,-42.29 0.48,-6.82 0.94,-13.41 1.37,-19.51 v -0.16 l 0.14,-0.06 33.55,-14.23 9.75,-4.09 2.62,-1.08 0.68,-0.26 z"
        fill={theme.text}
        id="path1307"
      />
      <path
        d="m 182.2,278.6 a 5.67,5.67 0 0 1 -1.31,-0.36 l -3.51,-1.13 a 77,77 0 0 0 -11.76,-3 34.32,34.32 0 0 0 -12,0.16 47.42,47.42 0 0 0 -4.82,1.39 6.73,6.73 0 0 1 1.21,-0.61 21.28,21.28 0 0 1 3.53,-1.14 32.1,32.1 0 0 1 12.19,-0.31 65.43,65.43 0 0 1 11.79,3.13 c 1.47,0.52 2.65,1 3.47,1.29 a 7,7 0 0 1 1.21,0.58 z"
        fill={theme.text}
        id="path1309"
      />
      <path
        d="m 175.6,267.89 a 32.93,32.93 0 0 0 -4.07,0 c -1.26,0.08 -2.75,0.28 -4.42,0.47 -1.67,0.19 -3.48,0.42 -5.37,0.78 a 24.81,24.81 0 0 0 -9.14,3.39 27.84,27.84 0 0 0 -3.17,2.55 3.48,3.48 0 0 1 0.68,-0.88 13.89,13.89 0 0 1 2.28,-2 23.45,23.45 0 0 1 9.25,-3.59 c 1.91,-0.37 3.75,-0.58 5.42,-0.75 1.67,-0.17 3.17,-0.32 4.45,-0.36 a 16.28,16.28 0 0 1 3,0.13 3.47,3.47 0 0 1 1.09,0.26 z"
        fill={theme.text}
        id="path1311"
      />
      <path
        d="m 130.13,173 c 0,0 -7.93,25.43 -7.75,32.71 0.18,7.28 3.2,28 2.85,32 -0.35,4 1.08,15.32 6,15.32 h 49.36 c 0,0 11.15,-3.09 11.63,-9.78 0.48,-6.69 -15,-71.66 -15,-71.66 0,0 -2.92,-11.94 -7,-12.81 -4.08,-0.87 -8.64,0 -11.37,8.43 -2.73,8.43 -3.64,20.33 -9.47,26.16 -5.83,5.83 -14.12,12.37 -14.12,12.37 0,0 -6.69,-5.6 -7,-13.18 -0.31,-7.58 2.54,-19.85 2.54,-19.85 z"
        style={{
          fill: "#ff725e",
        }}
        id="path1313"
      />
      <path
        d="m 182.09,177.46 a 10.61,10.61 0 0 0 -5.43,-4.17 25.82,25.82 0 0 0 -6.82,-1.31 18.23,18.23 0 0 0 -6.21,0.22 c -2,0.52 -2.84,3 -3.68,4.92 a 62.09,62.09 0 0 0 1.33,25.63 8.11,8.11 0 0 0 4.33,6 12.73,12.73 0 0 0 5.71,2.32 c 3.7,0.28 7.11,-2.4 8.84,-5.68 1.73,-3.28 2.12,-7.08 2.47,-10.77 q 0.35,-3.47 0.67,-6.93 c 0.34,-3.5 0.62,-7.26 -1.21,-10.23 z"
        style={{
          fill: "#a36957",
        }}
        id="path1315"
      />
      <path
        d="m 137.44,253.65 a 4.68,4.68 0 0 1 -1.95,-1 11.68,11.68 0 0 1 -3.3,-4.18 22.21,22.21 0 0 1 -1.68,-5 8.28,8.28 0 0 1 -0.34,-2.17 10.23,10.23 0 0 1 0.69,2.08 30.46,30.46 0 0 0 1.8,4.9 13.06,13.06 0 0 0 3.06,4.13 c 1,0.8 1.76,1.16 1.72,1.24 z"
        fill={theme.text}
        id="path1317"
      />
      <path
        d="m 163.56,222.13 a 4.43,4.43 0 0 1 -0.83,0.7 16.29,16.29 0 0 1 -2.55,1.49 15.61,15.61 0 0 1 -4.22,1.26 14.54,14.54 0 0 1 -5.38,-0.23 17.72,17.72 0 0 1 -8.38,-4.87 21.58,21.58 0 0 1 -1.93,-2.23 4.94,4.94 0 0 1 -0.58,-0.92 c 0.08,-0.06 1,1.2 2.76,2.89 a 18.47,18.47 0 0 0 8.25,4.62 15.15,15.15 0 0 0 9.3,-0.84 c 2.29,-1 3.5,-2 3.56,-1.87 z"
        fill={theme.text}
        id="path1319"
      />
      <path
        d="m 136.83,252.73 c -0.11,0.09 -0.79,-0.69 -1,-1.9 a 2.72,2.72 0 0 1 0.22,-2.15 c 0.15,0 0.07,0.95 0.29,2 0.22,1.05 0.66,1.97 0.49,2.05 z"
        fill={theme.text}
        id="path1321"
      />
      <path
        d="m 157.28,177.34 a 2.67,2.67 0 0 0 -1.21,0.61 2.8,2.8 0 0 0 -0.77,1.39 2.18,2.18 0 0 0 0.45,2 l 0.18,0.18 -0.25,0.08 a 4.65,4.65 0 0 0 -2.79,2.5 4.78,4.78 0 0 0 0.1,4.51 l 0.3,0.49 -0.56,-0.15 a 3.3,3.3 0 0 0 -3.58,5 l -0.46,0.23 a 1.83,1.83 0 0 0 -2.28,-0.88 2.81,2.81 0 0 0 -1.95,2 10.59,10.59 0 0 0 -0.42,3 l -0.04,1.4 -0.43,-1.38 a 1.68,1.68 0 0 0 -1.86,-1 2.36,2.36 0 0 0 -1.67,1.4 c -0.66,1.41 -0.26,3 0,4.29 h -0.4 a 2.22,2.22 0 0 0 -0.85,-1.72 2.6,2.6 0 0 0 -1.66,-0.62 2.17,2.17 0 0 0 -2,1.81 2.63,2.63 0 0 0 0.24,1.86 c 0.22,0.38 0.42,0.53 0.4,0.56 a 1.41,1.41 0 0 1 -0.5,-0.5 2.84,2.84 0 0 1 0.27,-3.3 2.22,2.22 0 0 1 1.6,-0.76 2.94,2.94 0 0 1 1.91,0.66 2.67,2.67 0 0 1 1,2 v 1.65 l -0.39,-1.6 a 13.91,13.91 0 0 1 -0.42,-2.17 4.53,4.53 0 0 1 0.35,-2.41 2.8,2.8 0 0 1 2,-1.69 2.16,2.16 0 0 1 2.42,1.31 l -0.49,0.07 a 11,11 0 0 1 0.44,-3.11 4.29,4.29 0 0 1 0.81,-1.46 3,3 0 0 1 1.5,-0.9 3,3 0 0 1 1.69,0 1.93,1.93 0 0 1 1.21,1.17 l 0.72,2 -1.18,-1.81 a 3.78,3.78 0 0 1 4.13,-5.74 l -0.26,0.35 a 5.17,5.17 0 0 1 -0.06,-4.92 4.92,4.92 0 0 1 3.06,-2.64 l -0.07,0.26 a 2.41,2.41 0 0 1 -0.46,-2.25 2.87,2.87 0 0 1 0.9,-1.45 2.27,2.27 0 0 1 0.95,-0.48 1.47,1.47 0 0 1 0.38,0.16 z"
        style={{
          fill: "#ff725e",
        }}
        id="path1323"
      />
      <path
        d="m 130.37,173.18 c 0,0 0.06,0 0.14,0.19 a 1.71,1.71 0 0 1 0.18,0.67 2.2,2.2 0 0 1 -0.23,1.1 2,2 0 0 1 -1.15,1 v -0.23 a 3.89,3.89 0 0 1 1.41,3 4.15,4.15 0 0 1 -2,3.72 v -0.37 a 4.08,4.08 0 0 1 1.38,4.19 11,11 0 0 1 -2.44,4.33 l -0.41,-0.32 a 1.91,1.91 0 0 1 3,0.23 3,3 0 0 1 0.1,2.89 7,7 0 0 1 -1.72,2.13 l -0.26,-0.43 a 2.84,2.84 0 1 1 1.76,5.39 l -0.57,0.16 0.34,-0.49 a 2.11,2.11 0 0 1 2.05,-0.77 3.13,3.13 0 0 1 1.76,0.84 4,4 0 0 1 1.07,2.87 10,10 0 0 1 -0.16,1.94 2.79,2.79 0 0 1 -0.15,0.66 c -0.08,0 0.13,-0.94 0.07,-2.59 a 3.84,3.84 0 0 0 -1.06,-2.63 2.93,2.93 0 0 0 -1.48,-0.66 1.73,1.73 0 0 0 -1.65,0.65 l -0.23,-0.33 a 2.51,2.51 0 0 0 1.63,-2.83 2.45,2.45 0 0 0 -3.1,-1.67 l -1.16,0.41 0.9,-0.84 a 6.55,6.55 0 0 0 1.59,-2 2.43,2.43 0 0 0 -0.06,-2.37 1.41,1.41 0 0 0 -2.16,-0.22 l -0.41,-0.31 a 10.67,10.67 0 0 0 2.37,-4.11 3.62,3.62 0 0 0 -1.15,-3.73 l -0.29,-0.2 0.31,-0.18 a 3.75,3.75 0 0 0 1.83,-3.32 3.65,3.65 0 0 0 -1.21,-2.81 L 129,176 l 0.25,-0.07 a 1.77,1.77 0 0 0 1,-0.85 2.09,2.09 0 0 0 0.27,-1 2.44,2.44 0 0 0 -0.15,-0.9 z"
        style={{
          fill: "#ff725e",
        }}
        id="path1325"
      />
      <g
        style={{
          opacity: 0.3,
        }}
        id="g1329"
      >
        <path
          d="m 140.52,218.47 a 14.4,14.4 0 0 0 5.07,9.7 11.93,11.93 0 0 0 10.56,2.3 10.25,10.25 0 0 0 7.22,-7.84 29.87,29.87 0 0 1 -7.88,2.74 15.46,15.46 0 0 1 -15.21,-7.18 c 0.13,0.15 0.27,0.29 0.4,0.43"
          id="path1327"
        />
      </g>
      <g
        style={{
          opacity: 0.3,
        }}
        id="g1333"
      >
        <path
          d="m 130.15,242 a 11.06,11.06 0 0 0 3.52,10.3 2.35,2.35 0 0 0 2.21,0.75 26.38,26.38 0 0 1 -5.67,-11.28"
          id="path1331"
        />
      </g>
      <path
        d="m 168.84,169.07 c 0,0 -11.17,1.75 -8.47,17.63 2.7,15.88 22,42.77 22,42.77 l -42.19,25.73 4.92,11.43 54.79,-22.55 c 0,0 5.4,-5.56 3.5,-11.75 -1.9,-6.19 -16,-45.18 -16,-45.18 0,0 -5.21,-20.78 -18.55,-18.08 z"
        style={{
          fill: "#a36957",
        }}
        id="path1335"
      />
      <path
        d="m 103.37,265 15.1,-9.54 20,0.94 1.68,-1.16 4.92,11.43 c 0,0 -5.39,2.58 -8.21,2.81 l -17.47,-1.33 -18.56,-1.39 z"
        style={{
          fill: "#a36957",
        }}
        id="path1337"
      />
      <path
        d="m 182.32,229.78 a 9.32,9.32 0 0 1 -1,-1.29 c -0.6,-0.85 -1.45,-2.1 -2.48,-3.65 -2.05,-3.12 -4.78,-7.49 -7.59,-12.44 -2.81,-4.95 -5.15,-9.54 -6.77,-12.9 -0.81,-1.68 -1.44,-3.05 -1.86,-4 A 8.43,8.43 0 0 1 162,194 a 10.09,10.09 0 0 1 0.78,1.42 l 2,3.93 c 1.7,3.31 4.1,7.86 6.9,12.8 2.8,4.94 5.47,9.34 7.44,12.5 l 2.34,3.74 a 9.43,9.43 0 0 1 0.86,1.39 z"
        style={{
          fill: "#7c3b29",
        }}
        id="path1339"
      />
      <path
        d="m 192.7,233.4 a 36.41,36.41 0 0 0 -5,-2.63 36.2,36.2 0 0 0 -5.55,-1.3 13.67,13.67 0 0 1 10.6,3.93 z"
        style={{
          fill: "#7c3b29",
        }}
        id="path1341"
      />
      <path
        d="m 42.55,217.33 c 0.38,1.16 15.54,52.11 15.54,52.11 l 87,6.25 3.2,-5.4 -48.58,-3.66 -13.63,-52.28 a 4.38,4.38 0 0 0 -4.92,-3.21 z"
        fill={theme.text}
        id="path1343"
      />
      <path
        d="m 70,238.71 c 0.73,1.52 0.43,3.18 -0.69,3.72 -1.12,0.54 -2.61,-0.25 -3.34,-1.76 -0.73,-1.51 -0.43,-3.18 0.68,-3.72 1.11,-0.54 2.62,0.25 3.35,1.76 z"
        fill={theme.compImgHighlight}
        id="path1345"
      />
      <path
        d="m 146.62,273.13 h -0.26 -0.73 l -2.85,-0.16 -10.54,-0.7 -35.3,-2.54 h -0.18 l -0.05,-0.17 c -0.47,-1.64 -1,-3.38 -1.48,-5.14 L 84.56,226.86 81.39,215.48 c -0.36,-1.32 -0.64,-2.36 -0.84,-3.11 -0.08,-0.33 -0.15,-0.59 -0.2,-0.81 a 0.93,0.93 0 0 1 -0.06,-0.28 1,1 0 0 1 0.11,0.27 c 0.06,0.21 0.15,0.47 0.25,0.8 0.23,0.74 0.54,1.76 0.93,3.07 l 3.34,11.34 10.82,37.47 c 0.5,1.76 1,3.5 1.47,5.14 l -0.23,-0.19 35.29,2.71 10.52,0.86 2.84,0.25 0.74,0.08 a 0.79,0.79 0 0 1 0.25,0.05 z"
        fill={theme.text}
        id="path1347"
      />
      <path
        d="m 158.87,117.44 -0.08,-3.92 -23.68,-3.52 c -7.28,-0.47 -14.81,7.1 -15,14.39 -0.18,8.1 -0.08,18 1.12,24 2.42,12 11.77,13.21 11.77,13.21 l 0.54,12 26.81,-0.75 z"
        style={{
          fill: "#a36957",
        }}
        id="path1349"
      />
      <path
        d="m 125.15,132.88 a 1.54,1.54 0 0 0 1.56,1.5 1.49,1.49 0 0 0 1.55,-1.46 1.56,1.56 0 0 0 -1.56,-1.51 1.49,1.49 0 0 0 -1.55,1.47 z"
        fill={theme.text}
        id="path1351"
      />
      <path
        d="m 122.9,129.45 c 0.2,0.19 1.35,-0.73 3,-0.79 1.65,-0.06 2.93,0.72 3.1,0.51 0.17,-0.21 -0.12,-0.45 -0.67,-0.82 a 4.3,4.3 0 0 0 -2.5,-0.66 4.14,4.14 0 0 0 -2.39,0.88 c -0.44,0.43 -0.63,0.79 -0.54,0.88 z"
        fill={theme.text}
        id="path1353"
      />
      <path
        d="m 140.78,132.54 a 1.57,1.57 0 0 0 1.56,1.51 1.5,1.5 0 0 0 1.55,-1.47 1.55,1.55 0 0 0 -1.56,-1.51 1.5,1.5 0 0 0 -1.55,1.47 z"
        fill={theme.text}
        id="path1355"
      />
      <path
        d="m 139.36,129.09 c 0.2,0.2 1.34,-0.72 3,-0.78 1.66,-0.06 2.93,0.72 3.11,0.51 0.18,-0.21 -0.13,-0.46 -0.68,-0.82 a 4.19,4.19 0 0 0 -2.49,-0.66 4,4 0 0 0 -2.39,0.88 c -0.49,0.41 -0.65,0.78 -0.55,0.87 z"
        fill={theme.text}
        id="path1357"
      />
      <path
        d="m 133.79,141.74 a 11.62,11.62 0 0 0 -2.74,-0.38 c -0.43,0 -0.83,-0.09 -0.92,-0.38 a 2.2,2.2 0 0 1 0.24,-1.28 c 0.36,-1 0.73,-2.15 1.13,-3.3 1.56,-4.7 2.68,-8.56 2.49,-8.62 -0.19,-0.06 -1.61,3.7 -3.18,8.4 -0.38,1.16 -0.74,2.26 -1.08,3.32 a 2.49,2.49 0 0 0 -0.15,1.68 1.06,1.06 0 0 0 0.73,0.6 2.76,2.76 0 0 0 0.73,0.07 10.63,10.63 0 0 0 2.75,-0.11 z"
        fill={theme.text}
        id="path1359"
      />
      <path
        d="m 133,161.62 a 32.16,32.16 0 0 0 16.47,-5 c 0,0 -3.75,8.65 -16.34,8 z"
        style={{
          fill: "#7c3b29",
        }}
        id="path1361"
      />
      <path
        d="m 134.66,145.74 a 3,3 0 0 1 2.66,-1.23 2.75,2.75 0 0 1 1.94,1 1.75,1.75 0 0 1 0.21,2 2,2 0 0 1 -2.17,0.64 6.42,6.42 0 0 1 -2.19,-1.19 2.07,2.07 0 0 1 -0.5,-0.48 0.56,0.56 0 0 1 0,-0.62"
        style={{
          fill: "#7c3b29",
        }}
        id="path1363"
      />
      <path
        d="m 138.76,142.7 c -0.27,0 -0.2,1.81 -1.71,3.16 -1.51,1.35 -3.44,1.23 -3.44,1.49 0,0.26 0.44,0.33 1.26,0.32 a 4.55,4.55 0 0 0 2.88,-1.14 3.91,3.91 0 0 0 1.31,-2.64 c 0.04,-0.76 -0.18,-1.21 -0.3,-1.19 z"
        fill={theme.text}
        id="path1365"
      />
      <path
        d="m 138.66,122.56 c 0.18,0.44 1.84,0.16 3.81,0.32 1.97,0.16 3.58,0.63 3.83,0.21 0.11,-0.2 -0.19,-0.62 -0.84,-1 a 6.63,6.63 0 0 0 -5.82,-0.41 c -0.71,0.32 -1.06,0.66 -0.98,0.88 z"
        fill={theme.text}
        id="path1367"
      />
      <path
        d="m 123.32,124.58 c 0.31,0.37 1.45,-0.07 2.83,-0.15 1.38,-0.08 2.57,0.16 2.83,-0.25 0.11,-0.2 -0.09,-0.57 -0.62,-0.91 a 3.9,3.9 0 0 0 -2.33,-0.53 4,4 0 0 0 -2.23,0.85 c -0.47,0.41 -0.62,0.81 -0.48,0.99 z"
        fill={theme.text}
        id="path1369"
      />
      <path
        d="m 117,109.72 c 2,4.24 6.32,10.55 11,11 a 13.71,13.71 0 0 0 12.19,-5.5 c 0.78,3.44 4.66,5.19 8.15,5.68 a 13.79,13.79 0 0 0 7.35,-0.67 7.34,7.34 0 0 0 4.55,-5.51 c 0.32,-2.47 -3.33,-8.44 -5.79,-8.85"
        fill={theme.text}
        id="path1371"
      />
      <path
        d="m 154.83,171.66 a 9.58,9.58 0 0 0 7,8.48 6.77,6.77 0 0 0 13.1,2.63 7.9,7.9 0 0 1 1,-2.29 c 1.18,-1.51 3.5,-1.21 5.32,-1.8 3.28,-1.06 4.7,-5.08 4.33,-8.51 a 8.22,8.22 0 0 1 -0.09,-2 c 0.2,-1.37 1.28,-2.42 2.08,-3.56 3.3,-4.68 1.92,-11.47 -1.74,-15.88 -1.22,-1.47 -2.76,-3 -2.64,-4.91 a 10.08,10.08 0 0 1 1,-3 8.67,8.67 0 0 0 -2.33,-9.45 2.69,2.69 0 0 1 -1,-1.2 2.59,2.59 0 0 1 0,-1 10.13,10.13 0 0 0 -8.56,-10.81 2.46,2.46 0 0 1 -0.89,-0.2 c -0.78,-0.41 -0.81,-1.48 -0.91,-2.35 -0.27,-2.31 -2,-6.61 -3.81,-8.12 -4.9,-4.18 -9.64,-0.78 -11.33,0.81 0,0 -3.35,16.6 -2.7,19.7 0.65,3.1 2.92,10.8 2,14.3 -0.92,3.5 -2.37,10.67 -1,13.83 1.37,3.16 1.17,15.33 1.17,15.33 z"
        fill={theme.text}
        id="path1373"
      />
      <path
        d="m 173.13,118.25 c 0,0 -0.21,0.22 -0.64,0.53 a 16.92,16.92 0 0 1 -1.94,1.16 23.77,23.77 0 0 1 -14.55,2.39 14.79,14.79 0 0 1 -2.22,-0.49 3,3 0 0 1 -0.78,-0.28 c 0,-0.09 1.17,0.2 3,0.41 a 27.64,27.64 0 0 0 7.33,-0.19 26.88,26.88 0 0 0 7,-2.17 c 1.76,-0.79 2.75,-1.43 2.8,-1.36 z"
        fill={theme.text}
        id="path1375"
      />
      <path
        d="m 174.73,119.43 a 4.68,4.68 0 0 1 -0.36,1 8.22,8.22 0 0 1 -0.53,1.11 13.69,13.69 0 0 1 -0.81,1.41 21.78,21.78 0 0 1 -2.62,3.35 24.65,24.65 0 0 1 -4,3.34 25.09,25.09 0 0 1 -4.64,2.36 21.52,21.52 0 0 1 -4.11,1.08 13.45,13.45 0 0 1 -1.62,0.2 9.05,9.05 0 0 1 -1.23,0 3.62,3.62 0 0 1 -1.05,-0.06 c 0,-0.1 1.5,-0.08 3.83,-0.54 a 23.93,23.93 0 0 0 4,-1.17 24.54,24.54 0 0 0 8.47,-5.58 23.78,23.78 0 0 0 2.65,-3.22 c 1.36,-1.94 1.92,-3.32 2.02,-3.28 z"
        fill={theme.text}
        id="path1377"
      />
      <path
        d="m 166.05,181.1 c 0,0 0.21,0 0.58,-0.06 a 2.62,2.62 0 0 0 1.39,-0.84 3.52,3.52 0 0 0 0.91,-2.38 11.39,11.39 0 0 0 -0.63,-3.44 A 7.48,7.48 0 0 1 168,170 c 0.52,-1.58 1.78,-2.79 2.91,-4.09 a 8.16,8.16 0 0 0 1.45,-2.14 3.06,3.06 0 0 0 -0.08,-2.51 5.74,5.74 0 0 0 -1.88,-2 c -0.78,-0.57 -1.64,-1.07 -2.47,-1.68 a 5.42,5.42 0 0 1 -2,-2.37 3.72,3.72 0 0 1 0.31,-3 c 0.94,-1.73 2.41,-3 2.75,-4.63 a 5.56,5.56 0 0 0 -1.23,-4.45 19.56,19.56 0 0 0 -2.92,-3.12 19.91,19.91 0 0 1 -2.44,-2.63 8,8 0 0 1 -1.27,-2.41 5.11,5.11 0 0 1 -0.2,-1.71 2.45,2.45 0 0 1 0.11,-0.58 6.79,6.79 0 0 0 0.28,2.23 12.4,12.4 0 0 0 3.77,4.83 19.26,19.26 0 0 1 3,3.13 8.12,8.12 0 0 1 1.17,2.18 4.67,4.67 0 0 1 0.18,2.63 c -0.39,1.86 -1.92,3.16 -2.76,4.77 a 3.14,3.14 0 0 0 -0.28,2.59 4.89,4.89 0 0 0 1.81,2.12 c 0.79,0.59 1.66,1.09 2.46,1.68 a 6.21,6.21 0 0 1 2,2.19 3.52,3.52 0 0 1 0.08,2.91 8.26,8.26 0 0 1 -1.55,2.28 c -1.16,1.31 -2.38,2.48 -2.86,3.9 a 7.21,7.21 0 0 0 0.21,4.13 11.52,11.52 0 0 1 0.56,3.56 3.72,3.72 0 0 1 -1.05,2.5 2.59,2.59 0 0 1 -1.52,0.8 1.39,1.39 0 0 1 -0.49,-0.01 z"
        fill={theme.text}
        id="path1379"
      />
    </g>
  </svg>
    );
  }
}